/**
 * Thrown for any non-2xx portal response, carrying the status alongside the
 * parsed error body.
 *
 * The generated client throws the response body directly, which has no status,
 * and callers branch on one. Mirrors `AnvilApiError` so both clients report
 * failures the same way.
 *
 * Its own module rather than part of `./index`: tests mock `@/util/apiClient` to
 * stub `portalApi`, which would otherwise hide this too.
 */
export class PortalApiError extends Error {
  public readonly status: number

  constructor(
    status: number,
    /** The parsed error payload, as thrown by the generated client. */
    public readonly body?: unknown,
  ) {
    super(`Portal API request failed with status ${status}`)
    this.name = 'PortalApiError'
    this.status = status
  }
}

export default PortalApiError
